import { parseHTML } from '~/helpers';

/**
 * Renders recommendations using the Product Recommendations API.
 *
 * @attribute url - The recommendations endpoint.
 */
customElements.define(
  'product-recommendations',
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      fetch(this.getAttribute('url'))
        .then((response) => response.text())
        .then((response) => {
          const updatedElement = parseHTML(response, 'product-recommendations');

          if (updatedElement) {
            this.innerHTML = updatedElement.innerHTML;
          }

          /**
           * Prevent future updates.
           */
          this.updated = true;
        });
    }
  }
);
